// extracted by mini-css-extract-plugin
export default {"termsMain":"TermsPage_termsMain__B+G1v","container":"TermsPage_container__cTYjs"};